import classNames from 'classnames/bind';
import React from 'react';
import Button, { ButtonMode } from '../Button';
import Icon, { ICONS } from '../Icon';
import styles from './Toaster.module.scss';

const cx = classNames.bind(styles);

export enum ToasterMode {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

interface ToasterProps {
  onClose: () => void;
  textContent: JSX.Element;
  mode?: ToasterMode;
}

const ToastIcons: Record<ToasterMode, ICONS> = {
  [ToasterMode.SUCCESS]: ICONS.Check,
  [ToasterMode.ERROR]: ICONS.Alert,
  [ToasterMode.INFO]: ICONS.InfoFilled,
  [ToasterMode.WARNING]: ICONS.Warning,
};

const Toaster = ({ onClose, textContent, mode = ToasterMode.SUCCESS }: ToasterProps): React.ReactElement => {
  const icon = ToastIcons[mode];
  return (
    <div className={cx('body', mode)} data-testid="toaster">
      <Icon name={icon} />
      <div className={cx('text')}>{textContent}</div>
      <div className={cx('divider')} />
      <Button className={cx('close')} onClick={onClose} mode={ButtonMode.PLAIN}>
        <Icon name={ICONS.Times} />
      </Button>
    </div>
  );
};

export default Toaster;
